import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3d728676"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-banner"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "content-banner-img",
  src: "https://img2.qiuwenxinli.com/official-website/about-us/banner-1.png"
})], -1));
import MySeactionHeader from "@/components/common/my-seaction-header.vue";
import CompanyIntroduction from "@/components/about-us/company-introduction.vue";
import CompanyOriginator from "@/components/about-us/company-originator.vue";
import CompanyHistory from "@/components/about-us/company-history.vue";
import CompanyWelfare from "@/components/about-us/company-welfare.vue";
import { useMeta } from "vue-meta";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    useMeta({
      title: "关于我们",
      htmlAttrs: {
        lang: "en",
        amp: true
      },
      meta: [{
        name: "description",
        content: "全民幸福社,幸福就在这"
      }, {
        name: "kewords",
        content: "全民幸福社,幸福心理课,专业心理学导师教学,心理学读书"
      }]
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(MySeactionHeader, {
        title: "公司简介"
      }), _createVNode(CompanyIntroduction), _createVNode(MySeactionHeader, {
        title: "创始人简介"
      }), _createVNode(CompanyOriginator), _createVNode(MySeactionHeader, {
        title: "发展历程"
      }), _createVNode(CompanyHistory), _createVNode(MySeactionHeader, {
        title: "公益基金会"
      }), _createVNode(CompanyWelfare)]);
    };
  }
});